<template>
  <div class="warp">
    <BaseHeader />
    <main> 
        <PaymentSuccessLeft page="paymentSuccess" />

        <div id="payment"> 
          
          <figure>
                  <div class="topic second text-blue titillium-sb">{{ text.paymentBy }}</div>
                  <div class="pass">
                      <div class="bank">
                        <div class="text">
                            <p class="titillium-r">{{ paymentBy[0].description }}</p>
                            <!-- <i class="titillium-l"> {{ paymentBy[0].description }} </i> -->
                        </div>                            
                        <em v-html="paymentBy[0].icon"></em>
                      </div>
                      <!-- <div v-if="paymentBy.length " class="change-payment titillium-r"><a href="javascript:;" @click="changePaymentMethod()">{{ text.changePaymentMethod }}</a></div> -->
                  </div>

                  <div class="total-card">  
                  <!-- SCB Easy --> 
                  <div class="content">
                    <div class="text-center" > 
                      <PayingScbEasy></PayingScbEasy>
                    </div>  
                  </div>

                  <!-- FOOTER -->
                  <div class="top">
                     <label class="titillium-r">{{ text.Total }}</label>
                     <p class="titillium-r text-blue">{{ total }}</p>
                  </div> 

                  <div v-if="outstanding > 0 "  class="bottom">
                     <label class="titillium-r">{{ text.outstanding }}</label>
                     <p class="titillium-r">{{ outstanding_Decimal }}</p>
                  </div>
               </div>
               

            </figure>
         </div>
    </main>
  </div>
</template>

<script>
export default {
  data() {
    return {
      method: '', 
    }
  },
  mounted() {
    let billStatus = setInterval(() => {
      this.$store
        .dispatch('getBillDataStatus', this.$route.query.linkcode)
        .then(() => {
          if (this.$store.state.billDataStatus != 2) {
            let page =
              this.$store.state.billDataStatus <= 3
                ? 'paymentMethods'
                : 'billRecieve'
            clearInterval(billStatus)
            console.log(222)
            console.log(`/${page}/?linkcode=${this.$route.query.linkcode}`)
            // this.$router.push(
            //   `/${page}/?linkcode=${this.$route.query.linkcode}`
            // )
          }
        })
    }, 10000)
    if (this.$store.state.billBank) {
      var bank = this.$store.state.billBank.filter(item => {
        return item.paymentType == this.$route.params.method
      })
      if (bank.length > 0) {
        let qr = {}
        switch (this.$route.params.method) {
          case 'SCB Easy':
            this.method = 'SCB Easy'
            qr.trantype = 'S'
            break
        }
        qr.method = this.$route.params.method
        qr.refcode = this.$store.state.linkcode
        qr.amount = this.$store.state.amount
        qr.bubankid = bank[0].id
        this.$store.dispatch('getScbEasyLink', qr)
        console.log(222)
        console.log(JSON.stringify(qr))
      }
    } else {
      console.log(333)
      console.log('/paymentMethods/?linkcode=' + this.$route.query.linkcode)
      // this.$router.push(
      //   '/paymentMethods/?linkcode=' + this.$route.query.linkcode
      // )
    }
  },
  methods: {
    twoDecimal(val) {
      return parseFloat(val).toFixed(2)
    },
    intervalOnProcess() {},
    getMobileOperatingSystem() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera
      if (
        userAgent.match(/iPad/i) ||
        userAgent.match(/iPhone/i) ||
        userAgent.match(/iPod/i)
      ) {
        return 'iOS'
      } else if (userAgent.match(/Android/i)) {
        return 'Android'
      } else {
        return 'unknown'
      }
    }
  },
  computed: {
    total() {  
        return this.twoDecimal(this.$store.state.total)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },     
    paymentBy() {
      var paymentBy =  this.payment_methods.filter((res)=>{
        return res.paymentType == 'SCB Easy';
      }) 
      return paymentBy
    }, 
    payment_methods() {
      if (this.$store.state.billBank) {
        let banks = this.$store.state.billBank
        let isiOS =
          navigator.userAgent.match('iPad') ||
          navigator.userAgent.match('iPhone') ||
          navigator.userAgent.match('iPod')
        let isAndroid = navigator.userAgent.match('Android')
        banks.forEach(bank => {
          bank.disabled = false
          if (this.$store.state.language == 'EN') {
            bank.description = bank.description_en
          } else {
            bank.description = bank.description_th
          }
          switch (bank.paymentType) {
            case 'CreditCard':
              bank.icon = `<img src="${require('../assets/ic_Master.png')}"/>&nbsp;&nbsp;<img src="${require('../assets/Ic_Visa.png')}"/>&nbsp;<img src="${require('../assets/ic_Jcb.svg')}"/>`
              break
            case 'CreditUnion':
              bank.icon = `<img src="${require('../assets/Ic_Union.svg')}"/>`
              break
            case 'CreditQR':
              bank.icon = `<img src="${require('../assets/ic_QR.svg')}"/>`
              break
            case 'ThaiQR':
              bank.icon = `<img src="${require('../assets/icon-qr-payment.png')}" style="scale:1.2;" />`
              break
            case 'WeChat':
              bank.icon = `<img src="${require('../assets/Ic_WeChat.svg')}"/>`
              break
            case 'Alipay':
              bank.icon = `<img src="${require('../assets/ic_Alipay.svg')}"/>`
              break
            case 'SCB Easy':
              bank.disabled = !(isiOS || isAndroid)
              bank.icon = `<img src="${require('../assets/ic_scb_easy.png')}" style="scale:1.2;" />`
              break
          }
        })
        return banks
      } else {
        return []
      }
    }, 
    outstanding() {
      return this.$store.state.outstanding - this.$store.state.amount
    }, 
    outstanding_Decimal() {
      return this.twoDecimal(
        this.$store.state.outstanding - this.$store.state.amount
      )
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }, 
    text() {
      let obj = {}
      if (this.$store.state.language == 'TH') {
        obj = { 
          paymentType: 'เลือกวิธีชำระเงิน', 
          nextButton: 'ดำเนินการต่อ',
          linkExp: 'ลิงค์ชำรเงินนี้หมดอายุแล้ว', 
          paymentBy: 'ชำระเงินผ่าน', 
          changePaymentMethod: 'เปลี่ยนวิธีการชำระเงิน', 
          btndownloadQR: 'บันทึกคิวอาร์', 
          Total: 'ยอดรวม', 
          amountTotal: 'ยอดที่ระบุ', 
          outstanding: 'คงเหลือ',
          headQr: 'กรุณาสแกนคิวอาร์ เพื่อชําระเงิน',
          headQrdesc: 'โปรดรอซักครู่ กรุณาอย่าปิดเบราว์เซอร์ หรือทําการรีเฟรช หน้าจอหลังชําาระเงินแล้ว ระบบจะทําการพาคุณกลับสู่หน้าหลัก',
          headCredit: 'ระบุจำนวนเงินที่ต้องชำระ',
          headCreditdesc: '(ท่านสามารถทำรายการด้วยบัตรมากกว่า 1 ใบได้)',
          fullpaid: 'ชำระเต็มจำนวน',
        }
      } else {
        obj = { 
          paymentType: 'Payment Type', 
          nextButton: 'Next',
          linkExp: 'This link expire.', 
          paymentBy: 'Pay through', 
          changePaymentMethod: 'Change payment method', 
          btndownloadQR: 'Save QR ',  
          Total: 'Total ', 
          amountTotal: 'Amount ', 
          outstanding: 'Outstanding', 
          headQr: 'Please scan the QR. to pay',
          headQrdesc: 'Please wait a moment. Please do not close the browser. or refresh Screen after payment The system will take you back to the home page. ',
          headCredit: 'Specific the amount to pay',
          headCreditdesc: '(You can make transactions with more than 1 card.)',
          fullpaid: 'Pay in full',
        }
      }
      return obj
    }, 
  },

}
</script>

<style scoped>
.v-input__slot .v-input--selection-controls__input i.v-icon {
  color: rgba(0, 0, 0, 0.57);
}
</style>
